module.exports = __webpack_public_path__ + "img/account-icon.8123b655.svg";